import addRoute from '@/router/add-route';

const Notifications = () => import('@/modules/notifications/notifications.vue');
const NotificationForm = () => import('@/modules/notifications/notification-form.vue');
const EventNotifications = () => import('@/modules/notifications/event-notifications.vue');

const notifications = [
    addRoute({
        name: 'notifications',
        path: '/notifications',
        component: Notifications,
        root: {label: 'Automations', name: 'automations'},
    }),
    addRoute({
        name: 'view-notifications',
        path: '/notifications/events/:eventType/:view?',
        component: EventNotifications,
        root: {label: 'Automations', name: 'automations'},
    }),
    addRoute({
        name: 'add-notification',
        path: '/notifications/events/:eventType/bind/add',
        component: NotificationForm,
        root: {label: 'Automations', name: 'automations'},
    }),
    addRoute({
        name: 'edit-notification',
        path: '/notifications/events/:eventType/bind/:itemIndex',
        component: NotificationForm,
        root: {label: 'Automations', name: 'automations'},
    }),
];

export default notifications;
